import { postArticleRating } from 'core_main/api/articles';
import { PublicCallback } from 'globals/types';
import { validatePostArticleFeedbackParameters } from './helpers';
import { SubmitArticleFeedbackParameters } from './types';

export const submitArticleFeedback = (
  parameters: SubmitArticleFeedbackParameters,
  cb?: PublicCallback,
) => {
  const validationError = validatePostArticleFeedbackParameters(parameters);
  if (validationError) {
    return Promise.reject(validationError);
  }
  return postArticleRating({
    knowledgeBaseId: parameters.knowledgeBaseId,
    articleId: parameters.articleId,
    lang: parameters.lang,
    rating: parameters.rating,
  }).then((response) => {
    if (cb) cb(response);
  });
};
